import React, {Component} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as uiActions from '../../../actions/uiActions';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions' ;
import {isConfigRequested} from '../../../services/configurationWarningChecks';
import {configurationOrdered, initializeIconColor} from '../../../services/utils.service';
import {ProjectPaymentSettings} from '../completion/ProjectPaymentSettings'
import {userCan} from '../../../services/userRights.service';
import {price} from '../../../services/format.service';
import {priceFallback} from './CompletionLine';
import { TranslationContext } from "../../../context/TranslationContext";
import { Modal } from '../../../components/Modal';
import {ModalConfigurationDescription} from '../completion/Details';
import {isQuote} from '../../../services/restrictedConfiguration';
import { gtmPro } from "../../../services/gtmPro";
import ui from '../../../reducers/ui';
import MediaQuery from "react-responsive/src";
const cn = require('classnames');



class TotalsComponent extends Component {
  static contextType = TranslationContext;

  componentDidMount() {
    const {showSellingPrices} = this.props.ui;
    initializeIconColor(showSellingPrices);
  }

  componentDidUpdate(prevProps) {
    const t = this.context;
    const {configuration,uiActions} = this.props;
    const {showSellingPrices} = this.props.ui;
    const sellingTotal = configuration.price ? priceFallback(this.props.user,configuration.price,false) : null;
    if (prevProps.ui.showSellingPrices !== showSellingPrices) {
      initializeIconColor(showSellingPrices);
    }
    if (!sellingTotal && userCan.seeAndChangeSellingPrices && showSellingPrices) {
      uiActions.addMessage({
        id: 'cannot-compute-selling-price',
        className: 'warning',
        innerHTML: t('config3d_message_selling_price_missing_not_defined') || 'Le prix de vente total TTC n\'a pas pu être défini car le prix de vente n\'est pas renseigné sur une ou plusieurs lignes.'
      })
    } else {
      uiActions.removeMessage('cannot-compute-selling-price')
    }
  }

  togllePrice = (type, from = null) => {
    // GTM
    let name = "config3d_finalize_switch_price_display",
    subcategory = "Finalisation",
    subtemplate = "finalisation";
    if (from === "details") {
      name = "extranet.config3d.config3d_finalize_quote-modal_price";
      subcategory = "détails";
      subtemplate = "détails";
    }
    gtmPro().ctaOfConfiguration({
      name: name,
      category: "configurateur",
      subcategory: subcategory,
      type: "cta",
      from: "bottom"
    }, { template: "configurateur", subtemplate: subtemplate }, {}, "partner", "product", "user", "page")
    const {uiActions} = this.props;
    const {showSellingPrices,showBuyingPrices} = this.props.ui;
    if (showBuyingPrices || showSellingPrices) {
      if(showBuyingPrices && type==="buy") {
        uiActions.toggleBuyingPricesDisplay();
      } else if (showSellingPrices && type==="sell") {
        uiActions.toggleSellingPricesDisplay();
      } else {
        uiActions.toggleBuyingPricesDisplay();
        uiActions.toggleSellingPricesDisplay();
      }
    }
    else if (type==="buy") {
      uiActions.toggleBuyingPricesDisplay();
    } else {
      uiActions.toggleSellingPricesDisplay();
    }
  }
  displayBuyinPrice = () => {
    gtmPro().ctaOfConfiguration({
      name: "Buying_price_button",
      category: "configurateur",
      subcategory: "détails",
      type: "picto",
      from: "main"
    }, { template: "configurateur", subtemplate: "détails" }, {}, "partner", "product", "user", "page")
    this.props.uiActions.toggleBuyingPricesDisplay();
  }

  sendOrderMessage(action,reference){
    window.top.postMessage({action, configuration: { reference }},process.env.REACT_APP_EXTRANET)
  }

  state = {
    detailsModalIsOpen: false,
  };

  setDetailsModalIsOpen = (isOpen) => {
    this.setState({ detailsModalIsOpen: isOpen });
  }

  closeDetailsModal = () => {
    this.setState({ detailsModalIsOpen: false });
  };

  render() {
    const t = this.context;
    const {configuration, uiActions, actions, isDetailsModal, onRequestClose} = this.props;
    const {showSellingPrices, showBuyingPrices} = this.props.ui;
    const sellingTotal = configuration.price ? priceFallback(this.props.user, configuration.price,false) : null;
    const category = configuration.monument.category

    const addCustomLine = () => {
      gtmPro().ctaOfConfiguration({
      name: "extranet.config3d.config3d_finalize_footer_button_add-line",
      category: "configurateur",
      subcategory: "détails",
      type: "cta",
      from: "bottom"
    }, { template: "configurateur", subtemplate: "détails" }, {}, "partner", "product", "user", "page")

      uiActions.setEditedLineIndex(configuration.additional.lines.length);
      actions.pushItem('additional.lines', {
        title: '',
        description: '',
        price: {custom: 0}
      });
    }

    const titleButton = userCan.placeOrder() 
        ? t("config3d_finalize_button_order") || "Passer en commande"
        : t("config3d_finalize_footer_button_pre-order") || "Passer en précommande";

    const action = userCan.placeOrder() ? isQuote(configuration) ? "quotevariant.order" : "configuration.order" : isQuote(configuration) ? "quotevariant.preorder" : "configuration.preorder";
    const openDetailsModal = (showDetails = false, editButton = false) => {
      
      if (!this.state.detailsModalIsOpen && showSellingPrices && editButton) {
        // GTM
        gtmPro().ctaOfConfiguration({
          name: "ToggleEditButton",
          category: "configurateur",
          subcategory: "Détails",
          type: "picto",
          from: "right"
        }, {}, {}, "partner", "product", "user", "page")
      } else if(!this.state.detailsModalIsOpen && !editButton){
        // GTM
        gtmPro().ctaOfConfiguration({
          name: "extranet.config3d.config3d_actionbuttons_details",
          category: "configurateur",
          subcategory: "Détails",
          type: "cta",
          from: "right"
        }, {}, {}, "partner", "product", "user", "page")
      }
      if (!this.state.detailsModalIsOpen && showDetails) {
         this.setDetailsModalIsOpen(true);
      }
    };
    return (
      <div className="OrderTotals Prices d-flex justify-content-between">
        {isDetailsModal ? (
          <>
          {showSellingPrices && (<div className='row align-items-center'>
            <div className='col-7'></div>

            <div className='col-1 price toggle-buying-prices'>
              {userCan.seeBuyingPrices() && <div
                onClick={this.displayBuyinPrice}
                className="ToggleBuyingPrices mt-1">
                {showSellingPrices && (
                  <>
                    {showBuyingPrices ? (
                      <>
                        <span className="arrow-right-icon icon-medium text-dark-icon"></span>
                        <span className="calculator-icon icon-medium"></span>
                      </>
                    ) : (
                      <>
                        <span className="arrow-left-icon icon-medium text-dark-icon"></span>
                        <span className="calculator-icon icon-medium"></span>
                      </>
                    )}
                  </>
                )}
              </div>}
              {t("config3d_finalize_quote-modal_total") || "Total"}
            </div>

            <div className='col-2 Prices'>
            {showBuyingPrices && (
              <div className="Cell show">
                <div className="price-wrapper">
                  {configuration.price && (configuration.price.discounted || configuration.price.buying) ? (
                    <div className="price-title-wrapper">
                      <span className="price-title">{t("config3d_finalize_quote-modal_purchase-price") || "Prix d’achat"}</span>
                      <span className='price'>{price(configuration.price.discounted || Math.ceil(configuration.price.buying))} €
                        <small> { t("config3d_finalize_details_excl-vat") || "HT" }</small>
                      </span>
                    </div>
                    
                  ) : (
                    <span className='price'>{t("config3d_finalize_details_on-demand") || "Sur demande"}</span>
                  )}
                </div>
              </div>
            )}
            </div>

            <div className='col-2 Prices'>
              <div className="Cell show">
                <div className="price-wrapper">
                <div className="price-title-wrapper">
                  <span className="price-title">{t("config3d_finalize_quote-modal_selling-price") || "Prix de vente"}</span>
                  <span className="price text-dark">{sellingTotal ? price(Math.ceil(sellingTotal)) : '---'} €<small>{ t("config3d_finalize_details_vat") || "TTC" }</small></span>
                </div>
                </div>
              </div>
            </div>            
          </div>    
          )}

          <div className='border-color-top row align-items-center mx-0'>
            <div className='col-3'>
              {!configurationOrdered(configuration) && 
              <button 
                onClick={!isConfigRequested(false) && addCustomLine} 
                className={`AddCustomLine text-dark button-secondary button-medium flex-grow-1 ${isConfigRequested(false) ? "disabled" : ""}`} 
                disabled={isConfigRequested(false)} 
                style={{ flexBasis: "50%" }}>
                <span className="plus-icon icon-medium text-dark-icon" ></span>
                <span>
                  { t('config3d_finalize_footer_button_add-line') || "Ajouter une ligne" }
                </span>  
              </button>}
            </div>

            <div className='col-2'>
              <ProjectPaymentSettings />
            </div>

            <div className='col-2'>
              <div className="price-display d-flex justify-content-center align-items-center">
                <span className=""> {showSellingPrices ? t('config3d_finalize_quote-modal_price-off') : t('config3d_finalize_quote-modal_price-on')} </span>
                <div className="btn-wrapper">
                  <div className="cfg-switch btn-config">
                    <label className=''>
                      <input 
                        type="checkbox" 
                        checked={showSellingPrices}
                        onChange={() => this.togllePrice("sell", "details")} />
                      <span className="euro"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-5'>
              <button 
                disabled={
                  !configuration.project ||
                  !configuration.project.customer ||
                  (!userCan.placeOrder() && !userCan.preOrder()) ||
                  isConfigRequested(false)
                }
                className="button-primary button-medium text-cta float-right Order"
                onClick={() => {onRequestClose(); this.sendOrderMessage(action,configuration.reference)}}>
                <span className="true-icon icon-large text-cta-icon"></span>
                <div>{titleButton}</div>
              </button>
            </div>
          </div>
          </>
        ) : (
          <>
            <div className="price-display d-flex justify-content-left align-items-center flex-grow-1">
              {/* <span className=""> {showSellingPrices ? t('config3d_finalize_quote-modal_price-off') : t('config3d_finalize_quote-modal_price-on')} </span> */}
              <div className="btn-wrapper">
                <div className="cfg-switch btn-config">
                  <label style={{ marginBottom: '5px' }}>
                    <input 
                      type="checkbox" 
                      checked={showSellingPrices}
                      onChange={() => this.togllePrice("sell")} />
                    <span className="euro"></span>
                  </label>
                </div>
              </div>
            </div>

            {userCan.seeAndChangeSellingPrices() && (
            <div className={cn("Cell SellingPrice", {show: showSellingPrices})}>
              <div className="d-flex price-total-wrapper">
                <span>
                  { t("config3d_finalize_details_selling-price") || "Prix de vente total" }
                </span>
                <div className="text-dark">{sellingTotal ? price(Math.ceil(sellingTotal)) : '---'} €<small>{ t("config3d_finalize_details_vat") || "TTC" }</small></div>
              </div>
            </div>)}

            {showSellingPrices ? (
              <button onClick={() => openDetailsModal(true, true)} className="btn-config-secondary config-button-background text-dark config-button-hover btn-icon">
                <span className="edit-icon icon icon-large text-dark-icon"></span>
              </button>
              ) : (
                <button onClick={() => openDetailsModal(true)} className="btn-config-secondary config-button-background text-dark config-button-hover button-small">
                  <span className="edit-icon icon icon-medium text-dark-icon" style={{width:"16px"}}></span>
                  <span>{t("config3d_finalize_project-info_placeholder_view-details") || "Vue détaillée" }</span>
                </button>
              )
            }

            <Modal
              className="custom-modal" 
              isOpen={this.state.detailsModalIsOpen}
              onRequestClose={this.closeDetailsModal}>
              <ModalConfigurationDescription onRequestClose={this.closeDetailsModal} />
            </Modal>
          </>
        )}
      </div>
    );
  }
}

export const Totals = connect((state) => ({
  ui:state.ui,
  user:state.user}),
  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch),
    uiActions: bindActionCreators(uiActions, dispatch)
  }))(TotalsComponent);
